import React from 'react';
import '/public/css/pages/collection.css';
import PropTypes from 'prop-types';
import Link from 'components/AppSafeLink/AppSafeLink';
import FullTeaser from '../../components/FullTeaser/FullTeaser';
import Metatags from '../../components/Metatags/Metatags';
import ApmRelatedLinkListItemOverride from '../../components/AmatOverrides/ApmRelatedLinkListItemOverride';
import ApmRelatedLinkOverride from '../../components/AmatOverrides/ApmRelatedLinkOverride';
import LinkOverride from '../../components/AmatOverrides/LinkOverride';
import ApmCustomHtmlOverride from '../../components/AmatOverrides/ApmCustomHtmlOverride';
import { useRouter } from 'next/router';
import { fishForSocialMediaImage } from 'components/Metatags/MetaTagHelpers';
import { Body } from '@apmg/amat';

Date.prototype.addDays = function (days) {
  var date = new Date(this.valueOf());
  date.setDate(date.getDate() + days);
  return date;
};
const ContentList = ({ data: { contentList }, date, today }) => {
  const router = useRouter();
  const currentDate = router.query.date.replaceAll('-', '/');
  const img = fishForSocialMediaImage(contentList);

  function previousDay(selectedDate) {
    const date = new Date(selectedDate.replaceAll('-', '/'));
    return date.addDays(-1).toISOString().split('T')[0];
  }

  function nextDay(selectedDate) {
    const date = new Date(selectedDate.replaceAll('-', '/'));
    return date.addDays(1).toISOString().split('T')[0];
  }

  const previousDate = previousDay(currentDate);
  const nextDate = nextDay(currentDate);
  const isNextFuture = nextDate > today;

  return (
    <>
      <Metatags
        title={`Stories from ${date}`}
        fullSlug={`content/${currentDate}`}
        description={`Stories and episodes published on ${date}`}
        topic={`Stories from ${date}`}
        contentType="website"
        noFollow={true}
        image={img?.url}
        imageHeight={img?.height}
        imageWidth={img?.width}
        imageAlt={contentList?.primaryVisuals?.social?.shortCaption}
      />
      <section
        className="collection page-purpose"
        data-mpr-content-topic={`Stories from ${date}`}
      >
        <div className="page-header-nav">
          <Link href={`/content/${previousDate}`} passHref>
            <button className="btn btn-primary btn-slim">Previous</button>
          </Link>
          <div className="dateSelector">
            <form>
              <label>
                {/* date must be updated to work on Safari */
                /* <input
                  type="date"
                  name="contentDate"
                  max={today}
                  value={currentDate}
                  onChange={(e) => {
                    e.preventDefault();
                    router.push(`/content/${e.target.value}`);
                  }}
                /> */}
              </label>
            </form>
          </div>
          {isNextFuture ? (
            <button className="btn btn-primary btn-slim" disabled>
              Next
            </button>
          ) : (
            <Link href={`/content/${nextDate}`} passHref>
              <button className="btn btn-primary btn-slim">Next</button>
            </Link>
          )}
        </div>
        <div className="page-header-bottom-border"></div>
        <div className="collection collection-1col">
          {contentList?.body && (
            <div className="collection-body userContent">
              <Body
                nodeData={JSON.parse(contentList.body)}
                embedded={contentList.embeddedAssets}
                overrides={{
                  link: LinkOverride,
                  apm_related_link: ApmRelatedLinkOverride,
                  apm_related_link_list_item: ApmRelatedLinkListItemOverride,
                }}
              />
            </div>
          )}
          <div className="collection_items">
            {contentList.items.map((item, index) => {
              let isNewspartners = false;
              if (contentList.canonicalSlug === 'newspartners') {
                isNewspartners = true;
              }

              return (
                <FullTeaser
                  item={item}
                  newspartners={isNewspartners}
                  key={item.id}
                  priority={index === 0}
                />
              );
            })}
          </div>
        </div>
        <div className="page-header-bottom-border"></div>
        <div className="page-footer-nav">
          <Link href={`/content/${previousDate}`} passHref>
            <button className="btn btn-primary btn-slim">Previous</button>
          </Link>
          {isNextFuture ? (
            <button className="btn btn-primary btn-slim" disabled>
              Next
            </button>
          ) : (
            <Link href={`/content/${nextDate}`} passHref>
              <button className="btn btn-primary btn-slim">Next</button>
            </Link>
          )}
        </div>
      </section>
    </>
  );
};

ContentList.propTypes = {
  data: PropTypes.shape({
    contentList: PropTypes.object,
  }),
  date: PropTypes.string,
  today: PropTypes.string,
};

export default ContentList;
